import React, { useState, useEffect, useCallback } from "react";
import _flattern from "lodash/flatten";
import {
  Table,
  TableHeader,
  TableBody,
  TableVariant,
} from "@patternfly/react-table";
import TextEllipsis from "../general/TextEllipsis";

export default (props) => {
  const activities = props.activities;

  const headers = [
    { title: "Email" },
    { title: "Action" },
    { title: "Result" },
    { title: "Timestamp" },
  ];
  const activityRows = activities.map((activity) => ({
    cells: [
      activity.kerberos,
      {
        title: (
          <TextEllipsis text={activity.action} maxlength="120"></TextEllipsis>
        ),
      },
      activity.result,
      activity.updated_at,
    ],
  }));

  const [rows, setRows] = useState(activityRows);

  const renderRows = useCallback(() => {
    let renderedRows = [];
    props.activities.forEach((activity, index) => {
      renderedRows.push(activityToRow(activity, index));
    });

    return _flattern(renderedRows);
  }, [props]);

  useEffect(() => {
    // if props.activities changed, re-build the rows
    setRows(renderRows);
  }, [props, renderRows]);

  function activityToRow(activity, index) {
    return [
      {
        cells: [
          activity.kerberos,
          {
            title: (
              <TextEllipsis
                text={activity.action}
                maxlength="120"
              ></TextEllipsis>
            ),
          },
          activity.result,
          activity.updated_at,
        ],
      },
    ];
  }

  return (
    <>
      <Table
        aria-label="user-activity"
        variant={TableVariant.compact}
        cells={headers}
        rows={rows}
      >
        <TableHeader />
        <TableBody />
      </Table>
    </>
  );
};
